import React from 'react'
import "./header.css"
import profileImage from "../../assets/images/profile_.png"
import MyContext from '../../Context/AppContext'
import { Dehaze, ManageAccounts, ExitToApp, History, Email, AdminPanelSettings, ExpandMore, AccessTimeFilled, VerifiedUser, DoDisturbOn } from '@mui/icons-material';
import { AppBar, Avatar, IconButton, Menu, MenuItem, Toolbar } from '@mui/material';
import { useNavigate } from 'react-router-dom'

function Header() {
    const { openDrawer, setOpenDrawer, setContactUsModalOpen, handleNavigationAllow, resetJobDescriptionStatus, userDetails, setUsageModal, setUserDetails } = React.useContext(MyContext);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElAdmin, setAnchorElAdmin] = React.useState(null);
    const navigate = useNavigate();

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleOpenAdminMenu = (event) => {
        setAnchorElAdmin(event.currentTarget);
    };
    const handleCloseAdminMenu = () => {
        setAnchorElAdmin(null);
    };

    const goToAccountSettings = () => {
        let checkAllowedNavigation = handleNavigationAllow();
        if (checkAllowedNavigation) {
            setAnchorElUser(null);
            navigate('/app/settings');
        }
    }

    const goToUsers = (pagename) => {
        let checkAllowedNavigation = handleNavigationAllow();
        if (checkAllowedNavigation) {
            setAnchorElUser(null);
            setAnchorElAdmin(null);
            navigate(`/app/users/${pagename}`);
        }
    }

    const logOut = () => {
        localStorage.clear();
        resetJobDescriptionStatus();
        setUserDetails(null); // Clear user details state
        navigate('/');
    };

    const handleUsageHistory = () => {
        setAnchorElUser(null);
        setUsageModal({
            isOpen: true,
            userId: userDetails._id,
        });
    }

    return (
        <AppBar position="fixed" className='headerAppBar'>
            <Toolbar>
                {!openDrawer && (
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        className='menuButton_Header'
                        onClick={() => setOpenDrawer(!openDrawer)}
                    >
                        <Dehaze />
                    </IconButton>
                )}
                <span className={openDrawer ? 'headerTitle titleAdjustment ' : 'headerTitle'}>
                    Noah.ai
                </span>

                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenUserMenu}
                    color="inherit"
                >
                    <Avatar alt="Profile Picture" src={profileImage} />
                </IconButton>

                <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                >
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => goToAccountSettings()}>
                        <ManageAccounts />
                        <span>Account Settings</span>
                    </MenuItem>
                    {userDetails?.accountConfig?.permissions?.checkUsage &&
                        <MenuItem className='menuHeaderItemsContainer' onClick={() => handleUsageHistory()}>
                            <History />
                            <span>Usage History</span>
                        </MenuItem>
                    }
                    {userDetails?.accountConfig?.permissions?.approveRequest &&
                        <MenuItem className='menuHeaderItemsContainer' onClick={handleOpenAdminMenu}>
                            <AdminPanelSettings />
                            <span>Admin</span>
                            <ExpandMore />
                        </MenuItem>
                    }
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => setContactUsModalOpen(true)}>
                        <Email />
                        <span>Contact Us</span>
                    </MenuItem>
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => logOut()}>
                        <ExitToApp />
                        <span>Logout</span>
                    </MenuItem>
                </Menu>

                <Menu
                    sx={{ mt: '45px' }}
                    id="admin-menu"
                    anchorEl={anchorElAdmin}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElAdmin)}
                    onClose={handleCloseAdminMenu}
                >
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => goToUsers("pending-requests")}>
                        <AccessTimeFilled />
                        <span>Pending Requests</span>
                    </MenuItem>
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => goToUsers("approved-users")}>
                        <VerifiedUser />
                        <span>Approved Users</span>
                    </MenuItem>
                    <MenuItem className='menuHeaderItemsContainer' onClick={() => goToUsers("declined-users")}>
                        <DoDisturbOn />
                        <span>Declined Users</span>
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    )
}

export default Header
